export const QUICK_SEARCH_LIMIT = 40;
